import React from 'react';
import { observable } from "mobx";
import AgendamentoContainerService from "../../../../services/AgendamentoContainerService";
import moment from "moment";
import {formatarDataCustomHTMLSemHora, numericSortFunc, dataSortFunc, situacaoFormatter, splitQuebraLinha} from '../../../../utils/formatar';
import { buscaSemResultado } from '../../../../utils/mensagens';
import { sortCaret } from '../../../comum/components/Icones';
import { createPDFDetalhesAgendamento } from '../../../../utils/pdfDetalhesAgendamento';

import lscache from "lscache";

export default class AgendamentoStore {

    @observable AgendCntrLista;
    @observable qtdRegistros;
    @observable loading;
    @observable modalCancelar;
    @observable modalMensagem;
    @observable responseAcao;

    /** Paginação */
    @observable total;
    @observable hasNextPage;

    /** Infinite Scroll */
    @observable hasMore;
    @observable itens;

    /** Filtro */
    @observable filtroSelecionado;
    @observable filtrado;
    @observable atualiza;
    @observable msgFiltro;
    @observable carregandoLista;

    /** Select */
    @observable operacoes;
    @observable tiposAgendamento;
    @observable pendenciasAgendamento;
    @observable status;
    @observable tamanhos;
    @observable transportadoras;
    @observable dataInicial;
    @observable dataInicialPesquisa;
    @observable dataFinal;

    @observable container;
    @observable tamanhoContainer;
    @observable transportadora;
    @observable placa;
    @observable cnh;
    @observable booking;


    @observable operacoesPreenchido;
    @observable tiposPreenchido;
    @observable statusPreenchido;
    @observable idSelecionado;
    @observable modalEditarAgendamento;
    @observable edicaoAgendamento;
    @observable mensagemEdicaoAgendamento;
    @observable detalheCancel
    @observable tableMessage;
    @observable liberacaoLoading
    @observable listaAgendamentoResumo
    @observable atualizaFiltro
    @observable obsLiberacaoEspecial
    @observable datPreenchido

    @observable modalAlerta;

    /*@observable detalhesCancelamento;*/
    
    constructor() {
        this.detalheCancel = "";
        this.AgendCntrLista = [];
        this.qtdRegistros = null;
        this.loading = false;
        this.modalCancelar = false;
        this.modalMensagem = false;
        this.idSelecionado = false;
        this.responseAcao = false;
        this.modalAlerta = process.env.rig;

        /** Edição Agend. */
        this.modalEditarAgendamento = false;
        this.edicaoAgendamento = false;
        this.mensagemEdicaoAgendamento = false;
        this.erroPadraoEdicao = "Ocorreu um erro na verificação da edição do Agendamento";

        /** Select */
        /*this.detalhesCancelamento = null;*/
        this.pendenciasAgendamento = [];
        this.tiposAgendamentoTodos = [];
        this.tiposAgendamento = [];
        this.operacoes = [];
        this.status = [];
        this.tamanhos = [];
        this.transportadoras = [];
        this.itens = [];
        //this.dataInicial = lscache.get('agendamento-dataInicial') ? lscache.get('agendamento-dataInicial') : moment().add(0, 'day').format("YYYY-MM-DD");
        this.dataInicial = lscache.get('agendamento-dataInicial') ? moment(lscache.get('agendamento-dataInicial')) : moment();
        this.dataInicialPesquisa = this.dataInicial;
        this.dataFinal = lscache.get('agendamento-dataFinal') ? moment(lscache.get('agendamento-dataFinal')) : null;
        this.dataFinalPesquisa = this.dataInicial;
        this.StatusDAT = [
            { Codigo: 1, Descricao: "Agendamento com DAT" },
            { Codigo: 2, Descricao: "Recepcionado" },
            { Codigo: 3, Descricao: "Falha na recepção" },
        ]


        /** Campos */
        this.operacoesPreenchido = false;
        this.tiposPreenchido = false;
        this.statusPreenchido = false;
        this.liberacaoLoading = false
        this.datPreenchido = false;

        this.container  = lscache.get('agendamento-container')  ? lscache.get('agendamento-container') : "";
        this.tamanhoContainer  = lscache.get('agendamento-tamanhoContainer')  ? lscache.get('agendamento-tamanhoContainer') : null;
        this.transportadora  = lscache.get('agendamento-transp') && process.env.ssa  ? lscache.get('agendamento-transp') : null;
        this.placa      = lscache.get('agendamento-placa')      ? lscache.get('agendamento-placa') : "";
        this.cnh        = lscache.get('agendamento-cnh')        ? lscache.get('agendamento-cnh') : "";
        this.booking    = lscache.get('agendamento-booking')    ? lscache.get('agendamento-booking') : "";

        /** Paginação */
        this.total = null;
        this.hasNextPage = null;
        this.hasMore = false;
        this.toShow = 20;
        this.turn = 0;

        /** Filtros */
        this.carregandoLista = false
        this.atualiza = true;
        this.atualizaFiltro = true;
        this.filtrado = false;
        this.filtraDataCache = false;
        this.filtroSelecionado = [];
        this.tamanhoPagina = 100;
        this.filtrosObrigatorios = []; //["dataInicial","dataFinal"];
        this.msgFiltro = "";

        /** Colunas da Tabela */
        this.todasColunas = [{
            dataField: 'DscTipo',
            text: 'Tipo',
            headerStyle: () => {
                return { width: "200px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Data',
            text: 'Data',
            formatter: formatarDataCustomHTMLSemHora,      
            sort: true,
            sortCaret: sortCaret,
            sortFunc : dataSortFunc
        },{
            dataField: 'Hora',                                                                                                                                                                                                                                                                                                                                                  
            text: 'Hora',
            sort: true,
            sortCaret: sortCaret,
            sortFunc : numericSortFunc
        },{
            dataField: 'Placa',
            text: 'Placa',
            sort: true,
            sortCaret: sortCaret,
        },/*{
            dataField: 'PlacaCarret1',
            text: 'Placa Carreta',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'PlacaCarret2',
            text: 'Placa Carreta 2',
            sort: true,
            sortCaret: sortCaret,
        }*/{
            dataField: 'Carretas',
            text: 'Carretas',
            headerStyle: () => {
                return { width: "50px" };
            },
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'Cnh',
            text: 'CNH',
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'ApelidoArmador',
            text: 'Arm.',
            sort: true,
            sortCaret: sortCaret,
            hidden: process.env.ssa ? false : true,
            formatter: (cell) => cell === null ? '---' : cell
        }, {
            dataField: 'NumBooking',
            text: 'Booking',
            sort: true,
            sortCaret: sortCaret,
            hidden: true,
            formatter: (cell) => cell === null ? '---' : cell
        }, {
            dataField: 'LstBookings',
            text: 'Booking',
            sort: true,
            sortCaret: sortCaret,
            hidden: process.env.ssa ? false : true,
            formatter: (cell) => cell === null ? '---' : cell
        }, {
            dataField: 'LstCntrs',
            text: 'Cntr(s)',
            headerStyle: () => {
                return { width: "110px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'ApelidoTransp',
            text: 'Transp.',
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'UsuarioIncl',
            text: 'Usuário',
            headerStyle: () => {
                return { maxWidth: "60px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'StatusAgendamento',
            text: 'Situação',
            headerStyle: () => {
                return { maxWidth: "60px" };
            },
            formatter: situacaoFormatter,
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'StatusDoc',
            text: '',
            headerStyle: () => {
                return { maxWidth: "60px" };
            },
            formatter: situacaoFormatter,
            sort: false
        },{
            dataField: 'FichaEmergencia',
            text: '',
            headerStyle: () => {
                return { maxWidth: "20px" };
            },
            formatter: situacaoFormatter,
            sort: false
        }, {
            dataField: 'CodStatus',
            hidden: true
        }];

        this.colunas = this.todasColunas;
        this.obsLiberacaoEspecial = "";

        /** Serviços de Agendamento */
        this.agendamentoService = new AgendamentoContainerService();

        this.tableMessage = "";

        /* Tela de Detalhes do Agendamento */
        this.listaAgendamentoResumo = {}
    }

    carregarLista() {

        this.atualiza = false;
        this.filtrado = true;
        this.carregandoLista = true;

        if (!this.filtraDataCache) 
        {
            this.filtroSelecionado["dataInicial"] = this.dataInicialPesquisa;
            this.filtroSelecionado["dataFinal"] = this.dataFinalPesquisa;

            lscache.set(`agendamento-dataInicial`, this.dataInicialPesquisa, 15);
            lscache.set(`agendamento-dataFinal`, this.dataFinalPesquisa, 15);
        }
        else {
            this.filtraDataCache = false;
        }

        if(this.validacaoFiltros()){

            if(this.filtroSelecionado.length === 0) {
                this.filtroSelecionado["dataInicial"] = this.dataInicialPesquisa;
            }

            this.loading = true;
            this.AgendCntrLista = [];
            
            lscache.set('agendamento-filtro', true);

            this.agendamentoService.listar(this.filtroSelecionado).then(response => {
                if (response) {
                    if(response.data.ListaAgendCntr) {
                        this.AgendCntrLista = response.data.ListaAgendCntr;
                        //this.total = response.data.Total;
                        this.total = this.AgendCntrLista.length;
                        this.loadFirstTurn()
                        //this.hasNextPage = response.data.HasNextPage;
                        if(this.AgendCntrLista.length === 0){
                            this.tableMessage = buscaSemResultado
                        }
                    } else {
                        this.msgFiltro = response.data.Mensagem;
                    }
                } else {
                    this.total = 0;
                    this.tableMessage = buscaSemResultado
                    this.hasNextPage = false;
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => { this.loading = false; this.atualiza = true; this.carregandoLista = false});
        }
        else{
            this.atualiza = true;
            this.carregandoLista = false;
            {/** TODO: melhorar validação dos campos obrigatórios */}
            // this.modalCancelar = true;
            // this.responseAcao = "Preencha todos os filtros obrigatórios"
        }

    }

    fecharModalFiltro = () => {
        this.msgFiltro = "";
    }

    limparObsLiberacaoEspecial = () => 
    {
        this.obsLiberacaoEspecial = "";
    }

    limparFiltros = () => {
        
        setTimeout(function(){
            this.atualizaFiltro = false;
        }.bind(this),1);

        this.filtroSelecionado = [];

        lscache.remove('agendamento-tipoAgendId');
        lscache.remove('agendamento-dataInicial');
        //lscache.remove('agendamento-dataFinal'); 
        lscache.remove('agendamento-VesselvisitId'); 
        lscache.remove('agendamento-status');
        lscache.remove('agendamento-container');
        lscache.remove('agendamento-placa');
        lscache.remove('agendamento-cnh'); 
        lscache.remove('agendamento-booking');
        lscache.remove('agendamento-transp');


        this.tiposPreenchido = false;

        this.dataInicial = moment();
        this.dataFinal = null;

        this.dataInicialPesquisa = this.dataInicial;
        this.dataFinalPesquisa = this.dataFinal;

        this.operacoesPreenchido = false;

        this.statusPreenchido = false;
        this.datPreenchido = false;

        this.setContainer("");
        this.setPlaca("");
        this.setCnh("");
        this.setBooking("");
        
        setTimeout(function(){
            this.atualizaFiltro = true;
        }.bind(this),1);
    }

    loadFirstTurn = () => {
        this.itens = this.AgendCntrLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.itens.length < this.AgendCntrLista.length;
    };

    loadNextTurn = () => {
        this.itens = [];
        this.itens = this.AgendCntrLista.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn+1;

        this.hasMore = this.itens.length < this.AgendCntrLista.length;
    };

    carregarOperacoes() {
        this.operacoes = [];
        if (this.tiposPreenchido && this.tiposPreenchido.value) {
            const loadingPromises = Promise.all([
                this.agendamentoService.listarOperacoes(this.tiposPreenchido.value, "flagtrem").then(response => { // TODO Descobrir o que é flagtrem
                    this.operacoes = response.data;
                    // Verifica se existe algum filtro em memória
                    if (this.operacoes && 
                        this.operacoes.length > 0 &&
                        this.filtroSelecionado['VesselvisitId'])
                    {
                        this.operacoes.map(oper=> {
                            if (oper.Viagem === this.filtroSelecionado['VesselvisitId'])
                            {
                                // seta o filtro
                                this.setOperacao({label:oper.IdViagemDtPrev, value:oper.Viagem});
                            }
                        })
                    }


                }).catch(error => {
                    console.log(error);
                }),
            ]);
            loadingPromises.then(() => { }).catch((error) => { });
        }
    }

    carregarTipoAgendamento(){
        this.tiposAgendamento = [];
        const loadingPromises = Promise.all([
            this.agendamentoService.listarTipoAgendamento().then(response => {
                this.tiposAgendamentoTodos = response.data;
                this.tiposAgendamento = this.tiposAgendamentoTodos;
                // Verifica se existe algum filtro em memória
                if (this.tiposAgendamento && 
                    this.tiposAgendamento.length > 0 &&
                    this.filtroSelecionado['tipoAgendId'])
                {
                    this.tiposAgendamento.map(tipo=> {
                        if (tipo.Id === this.filtroSelecionado['tipoAgendId'])
                        {
                            // seta o filtro
                            this.setTipo({label:tipo.DscTipo, value:tipo.Id});
                        }
                    })
                }
            }).catch(error => {
                console.log(error);
            }),
        ]);
        loadingPromises.then(() => { }).catch((error) => { });
    }
    
    carregarPendenciasAgendamento(id){
        this.pendenciasAgendamento = [];

        const loadingPromises = Promise.all([
            this.agendamentoService.listarPendencias(id).then(response => {
                let msg = response.data;
                this.pendenciasAgendamento = splitQuebraLinha(msg);
            }).catch(error => {
                console.log(error);
            }),
        ]);
        loadingPromises.then(() => { }).catch((error) => { });
    }

    carregarDetalheCancel = async (id) => {
        
        try {
            const response = await this.agendamentoService.CarregarDetalheCancelamento(id);
            if (response) {
                return response.data;
            }
        } catch (error){
            console.log(error);
        }
    }

    carregarStatus(){
        this.status = [];

        const loadingPromises = Promise.all([
            this.agendamentoService.listarStatus().then(response => {
                this.status = response.data;
                // Verifica se existe algum filtro em memória
                if (this.status && 
                    this.status.length > 0 &&
                    this.filtroSelecionado['status'])
                {
                    this.status.map(stat=> {
                        if (stat.Codigo === this.filtroSelecionado['status'])
                        {
                            // seta o filtro
                            this.setStatus({label:stat.Descricao, value:stat.Codigo});
                        }
                    })
                }


            }).catch(error => {
                console.log(error);
            }),
        ]);
        loadingPromises.then(() => { }).catch((error) => { });
    }

    carregarTamanhos() {
        this.tamanhos = [];
        const loadingPromises = Promise.all([
            this.agendamentoService.listarTamanhoCntr().then(response => {
                this.tamanhos = response.data;
                // Verifica se existe algum filtro em memória e se não houver na lista de tamanhos ele será excluido
                if(this.tamanhos.find(tam => this.tamanhoContainer && this.tamanhoContainer.value === tam.Codigo)){
                    this.filtroSelecionado["tamanhoContainer"] = this.tamanhoContainer.value;
                } else {
                    this.tamanhoContainer = null;
                    lscache.remove(`agendamento-tamanhoContainer`);
                }
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(() => { }).catch((error) => { });
    }

    carregarTransportadorasTipoSelecionado() {
        this.transportadoras = [];
        console.log('tipo', this.tiposPreenchido.value)
        if (this.tiposPreenchido.value == 286) {
            const loadingPromises = Promise.all([
                this.agendamentoService.listarTransportadorasPorMembershipDepot().then(response => {
                    this.transportadoras = response.data;
                    // Verifica se existe algum filtro em memória e se não houver na lista de transportadoras ele será excluido
                    if(this.transportadoras.find(transp => this.transportadora && this.transportadora.value === transp.transpId)){
                        this.filtroSelecionado["transpId"] = this.transportadora.value;
                    } else {
                        this.transportadora = null;
                        lscache.remove(`agendamento-transp`);
                    }
                }).catch(error => {
                    console.log(error);
                })
            ]);
            loadingPromises.then(() => { }).catch((error) => { });
        } else {
            const loadingPromises = Promise.all([
                this.agendamentoService.listarTransportadorasPorMembership().then(response => {
                    this.transportadoras = response.data;
                    // Verifica se existe algum filtro em memória e se não houver na lista de transportadoras ele será excluido
                    if(this.transportadoras.find(transp => this.transportadora && this.transportadora.value === transp.transpId)){
                        this.filtroSelecionado["transpId"] = this.transportadora.value;
                    } else {
                        this.transportadora = null;
                        lscache.remove(`agendamento-transp`);
                    }
                }).catch(error => {
                    console.log(error);
                })
            ]);
            loadingPromises.then(() => { }).catch((error) => { });
        }
        
    

    }



    carregarTransportadoras() {
        this.transportadoras = [];
        console.log('tipo', this.tiposPreenchido)
        const loadingPromises = Promise.all([
            
            this.agendamentoService.listarTransportadorasPorMembership().then(response => {
                this.transportadoras = response.data;
                // Verifica se existe algum filtro em memória e se não houver na lista de transportadoras ele será excluido
                if(this.transportadoras.find(transp => this.transportadora && this.transportadora.value === transp.transpId)){
                    this.filtroSelecionado["transpId"] = this.transportadora.value;
                } else {
                    this.transportadora = null;
                    lscache.remove(`agendamento-transp`);
                }
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(() => { }).catch((error) => { });

    }

    setFiltroSelecionado(campo, valor){
        this.filtroSelecionado[campo] = valor;
        lscache.set(`agendamento-${campo}`, valor, 15);     
    }


    setIdRow(id) {
        this.modalCancelar = "CANCELAR";
        this.idSelecionado = id ? id : false;
    };
    
    setIdResumo(id) {
        this.modalMensagem = "RESUMO";
        this.idSelecionado = id ? id : false;
    };
    
    setIdAgendamentoIncompleto(id) {
        this.modalMensagem = "INCOMPLETO";
        this.idSelecionado = id ? id : false;
        this.carregarPendenciasAgendamento(id);
    };

    setIdLiberacao(id) {
        this.modalCancelar = "LIBERAR";
        this.idSelecionado = id ? id : false;
    };

    setIdLiberacaoManual(id) {
        this.modalCancelar = "LIBERARMANUAL";
        this.idSelecionado = id ? id : false;
    };

    setIdCancelarDepot(id) {
        this.modalCancelar = "CANCELARDEPOT";
        this.idSelecionado = id ? id : false;
    };

    setIdReenvioBat(id) {
        this.modalCancelar = "REENVIAR_BAT";
        this.idSelecionado = id ? id : false;
    }

    confirmarAcao = () => {
        switch (this.modalCancelar) {
            case "CANCELAR":
                this.cancelarAgendamento(); break;
            case "LIBERAR":
                this.liberacaoEspecial(); break;
            case "LIBERARMANUAL":
                this.liberacaoManualDepot(); break;
            case "CANCELARDEPOT":
                this.cancelarDepot(); break;
            case "REENVIAR_BAT":
                this.reenviarBat(); break;
            case "RESUMO":
                this.modalMensagem = false; break;
            case "INCOMPLETO":
                this.modalMensagem = false; break;
            default: break;
        }
    };

    cancelarAgendamento() {
        this.agendamentoService.cancelarAgendamento({Id: this.idSelecionado}).then(response => {
            if (response.data) {
                if (response.data.Sucesso)
                    this.confirmaCancelou();
                this.responseAcao = response.data.Mensagem;                
            }
            this.modalCancelar = false;
            this.idSelecionado = false;
        }).catch(error => {
            this.responseAcao = error;
        });
    };

    confirmaCancelou = () => {
        let lista = this.AgendCntrLista;
        lista.forEach((agend, x) => {
            if (agend.AgendId == this.idSelecionado) {
                lista[x].CodStatus = "C";
                lista[x].StatusAgendamento = "Cancelado";
            }
        });
        this.AgendCntrLista = [];
        setTimeout(() => {
            this.AgendCntrLista = lista;
            this.carregarLista()
        }, 1000);
    };

    liberacaoEspecial = () => {
        this.liberacaoLoading = true
        this.agendamentoService.liberarEspecial({Id: this.idSelecionado, obsLiberaEspecial: this.obsLiberacaoEspecial}).then(response => {
            if (response.data) {
                if (response.data.Sucesso)
                    this.confirmaLiberou();
                this.responseAcao = response.data.Mensagem;
            } else if (response.status === 403){
                this.responseAcao = "Você não tem permissão para realizar esta ação."
            }
            this.liberacaoLoading = false
            this.modalCancelar = false;
            this.idSelecionado = false;
        }).catch(error => {
            this.responseAcao = error;
            this.liberacaoLoading = false
        });
    };

    liberacaoManualDepot= () => {
        this.liberacaoLoading = true
        this.agendamentoService.liberarManualDepot(this.idSelecionado, this.obsLiberacaoEspecial).then(response => {
            if (response.data) {
                if (response.data.Sucesso)
                    this.confirmaLiberouManual();
                this.responseAcao = response.data.Mensagem;
            } else if (response.status === 403){
                this.responseAcao = "Você não tem permissão para realizar esta ação."
            }
            this.liberacaoLoading = false
            this.modalCancelar = false;
            this.idSelecionado = false;
        }).catch(error => {
            this.responseAcao = error;
            this.liberacaoLoading = false
        });
    };

    cancelarDepot= () => {
        this.agendamentoService.cancelarDepot(this.idSelecionado, this.obsLiberacaoEspecial).then(response => {
            if (response.data) {
                if (response.data.Sucesso)
                    this.confirmaCancelouDepot();
                this.responseAcao = response.data.Mensagem;
            }
            this.modalCancelar = false;
            this.idSelecionado = false;
        }).catch(error => {
            this.responseAcao = error;
        });
    };

    confirmaCancelouDepot = () => {
        let lista = this.AgendCntrLista;
        lista.forEach((agend, x) => {
            if (agend.AgendId == this.idSelecionado) {
                lista[x].CodStatus = "C";
                lista[x].StatusAgendamento = "Cancelado";
            }
        });
        this.AgendCntrLista = [];
        setTimeout(() => {
            this.AgendCntrLista = lista;
            this.carregarLista()
        }, 1000);
    };

    reenviarBat = () => {
        this.agendamentoService.reenviarEmailBat(this.idSelecionado).then(response => {
            if (response && response.data) {
                this.responseAcao = response.data.Mensagem;
            }
            this.modalCancelar = false;
            this.idSelecionado = false;
        }).catch(error => {
            this.responseAcao = error;
        });
    };

    confirmaLiberou = () => {
        let listaAg = this.AgendCntrLista;
        listaAg.forEach((agend, x) => {
            if (agend.AgendId == this.idSelecionado) {
                listaAg[x].CodStatus = "L";
                listaAg[x].StatusAgendamento = "Lib. Especial";
            }
        });
        this.AgendCntrLista = [];
        setTimeout(() => {
            this.AgendCntrLista = listaAg;
            this.carregarLista()
        }, 1000);
    };

    confirmaLiberouManual = () => {
        let listaAg = this.AgendCntrLista;
        listaAg.forEach((agend, x) => {
            if (agend.AgendId == this.idSelecionado) {
                listaAg[x].CodStatus = "P";
                listaAg[x].StatusAgendamento = "Agendado";
            }
        });
        this.AgendCntrLista = [];
        setTimeout(() => {
            this.AgendCntrLista = listaAg;
            this.carregarLista()
        }, 1000);
    };

    fechaModais() {
        this.modalCancelar = false;
        this.modalMensagem = false;
        this.idSelecionado = false;
        this.responseAcao = false;
        this.modalEditarAgendamento = false;
        this.mensagemEdicaoAgendamento = false;
    };

    validacaoFiltros(){
        return this.filtrosObrigatorios.map(val => !!this.filtroSelecionado[val]).indexOf(false) === -1;
    }

    onChangeDataInicio = (data) => {

        if(data === null) {
            this.dataInicial = null;
        } else {
            this.dataInicial = moment(data);
        }
        this.dataInicialPesquisa = data;
        this.filtroSelecionado["dataInicial"] = data;
        this.filtraDataCache = false;
    };

    onChangeDataFim = (data) => {
        if(data === null) {
            this.dataFinal = null;
        } else {
            this.dataFinal = moment(data);
        }
        this.dataFinalPesquisa = data;
        this.filtroSelecionado["dataFinal"] = this.dataFinal;
        this.filtraDataCache = false;
    };

    setTipo = (valor) => {
        this.tiposPreenchido = valor;
        this.carregarOperacoes();
        this.incluirFiltro(this.tiposPreenchido, "tipoAgendId");
        this.carregarTransportadorasTipoSelecionado()
    };

    setContainer = (valor) => {
        this.container = valor;
        this.setFiltroSelecionado("container", valor)
    };
    setTamanhoContainer = (valor) => {
        this.tamanhoContainer = valor;
        if(valor !== null) {
            this.filtroSelecionado["tamanhoContainer"] = valor.value;
            lscache.set(`agendamento-tamanhoContainer`, valor, 15);
        } else {
            lscache.remove(`agendamento-tamanhoContainer`);
            delete this.filtroSelecionado["tamanhoContainer"];
        }
    }
    setTransportadora = (valor) => {
        this.transportadora = valor;
        if(valor !== null) {
            this.filtroSelecionado["transpId"] = valor.value;
            lscache.set(`agendamento-transp`, valor, 15);
        } else {
            lscache.remove(`agendamento-transp`);
            delete this.filtroSelecionado["transpId"];
        }
    }
    setPlaca = (valor) => {
        this.placa = valor;
        this.setFiltroSelecionado("placa", valor);
    };
    setCnh = (valor) => {
        this.cnh = valor;
        this.setFiltroSelecionado("cnh", valor);
    };
    setBooking = (valor) => {
        this.booking = valor;
        this.setFiltroSelecionado("booking", valor);
    };

    setDAT = (valor) => {
        this.datPreenchido = valor;
        this.incluirFiltro(valor, "dat");
    };
    
    setOperacao = (valor) => {
        this.operacoesPreenchido = valor;
        this.incluirFiltro(this.operacoesPreenchido, "VesselvisitId");
    };

    setStatus = (valor) => {
        this.statusPreenchido = valor;
        this.incluirFiltro(this.statusPreenchido, "status");
    };

    incluirFiltro(valor, filtro){
        (valor) ?  this.filtroSelecionado[filtro] = valor.value : delete this.filtroSelecionado[filtro];
        (valor) ?  lscache.set(`agendamento-${filtro}`, valor.value, 15) : lscache.remove(`agendamento-${filtro}`);
    }

    verificarEdicaoAgendamento = (idAgend) => {
        this.modalEditarAgendamento = true;
        this.loading = true;
        this.agendamentoService.verificarEdicaoAgendamento(idAgend)
            .then(response => {
                if(response.data && response.data.Sucesso){
                    this.edicaoAgendamento = idAgend;
                } else {
                    this.edicaoAgendamento = false;
                    this.mensagemEdicaoAgendamento = response.data.Mensagem ? response.data.Mensagem : this.erroPadraoEdicao;
                }
            })
            .catch(erro => {
                this.edicaoAgendamento = false;
                this.mensagemEdicaoAgendamento = this.erroPadraoEdicao
            })
            .finally(() => {
                this.loading = false;
            });
    }

    carregarAgendamentoResumo = async (id, tipoAgendamento, statusAgendamento) => {
        try
        {
         this.loading = true;
         let response = await this.agendamentoService.listarAgendamentoResumo(id);
            if(response && response.data){
                this.listaAgendamentoResumo = response.data;
                createPDFDetalhesAgendamento(this.listaAgendamentoResumo, tipoAgendamento, statusAgendamento);
            }else{
                this.listaAgendamentoResumo = {};
            }
        
        }
        catch(error)
        {
            console.log(error);
        }
        finally{ 
            this.loading = false;  
        };
    }

}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-visualizar/stores/AgendamentoStore.js